import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ActivityTypesDB extends GenericDB {
  constructor(clinicId) {
    super('', 'clinicSettings.activityTypes');
    this.clinicId = clinicId;
  }

  getCollectionRef() {
    return collection(db, 'clinicSettings', this.clinicId, 'activityTypes');
  }
}
